export const config = (
  translations,
  decisionTypeNameList,
  decisionStatus,
  enums
) => {
  const { createdAtFrom, createdAtTo } = translations || {};
  const { DecisionStatus } = enums || {};

  return {
    fields: [
      {
        key: 3,
        name: 'createdAtFrom',
        type: 'date',
        label: createdAtFrom,
      },
      {
        key: 4,
        name: 'createdAtTo',
        type: 'date',
        label: createdAtTo,
      },
      {
        key: 1,
        name: 'decisionStatus',
        type: 'autocomplete',
        label: 'decisionStatus',
        optionList: decisionStatus || [],
        getOptionLabel: (s) => DecisionStatus[s.constant]?.text || '',
      },
      {
        key: 2,
        name: 'decisionType.name',
        type: 'autocomplete',
        label: 'decisionType.name',
        optionList: decisionTypeNameList || [],
        getOptionLabel: (decisionType) => decisionType || '',
      },

      {
        key: 5,
        name: 'submitDateFrom',
        type: 'date',
        label: 'submitDateFrom',
      },
      {
        key: 6,
        name: 'submitDateTo',
        type: 'date',
        label: 'submitDateTo',
      },
      {
        key: 7,
        name: 'kjs',
        type: 'text',
        label: 'kjs',
        component: 'input',
      },
    ],
  };
};
